import styled, { css } from 'styled-components'
import LazyHydrate from 'react-lazy-hydration'
import { HabitatTextLogo } from '@sainsburys-tech/bolt-icons'

export const LazyHydrateCard = styled(LazyHydrate)`
  :nth-child(n) {
    border: 0;
    padding: 15px 0 30px;
  }

  :nth-child(n + 4) {
    border-top: 1px solid ${props => props.theme.tokens.color.monochrome.light};
  }

  @media (max-width: ${props => props.theme.tokens.breakpoints.maxWidth.extraSmall}) {
    max-width: calc(50% - 22.5px);

    :nth-child(n) {
      padding-bottom: 15px;
    }

    :nth-child(n + 3) {
      border-top: 1px solid ${props => props.theme.tokens.color.monochrome.light};
      padding-bottom: 15px;
    }

    :nth-child(odd) {
      margin-left: 15px;
      margin-right: 7.5px;
    }

    :nth-child(even) {
      margin-left: 7.5px;
      margin-right: 15px;
    }
  }
`

export const ProductList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0;

  @media screen and (min-width: ${props => props.theme.tokens.breakpoints.minWidth.large}) {
    margin: 0 -15px;
  }
`

export const WhiteGoodsWrapper = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`

export const ProductRelevancyHeader = styled.h4`
  line-height: 1.5rem;
  padding: 20px;

  @media (min-width: ${props => props.theme.tokens.breakpoints.minWidth.large}) {
    padding: 5px 0 5px 0;
  }

  ${props =>
    props.secondHeader &&
    css`
      margin-top: 20px;
      border: 1px solid ${props.theme.tokens.color.monochrome.light};
      border-width: 1px 0;
      padding: 20px;

      @media (max-width: ${props.theme.tokens.breakpoints.maxWidth.extraSmall}) {
        background-color: ${props.theme.tokens.color.monochrome.lighter};
      }

      @media (min-width: ${props.theme.tokens.breakpoints.minWidth.large}) {
        padding: 20px 0;
      }
    `}
`
export const ProductRelevancyHeaderName = styled.div`
  margin-bottom: 0;
`
export const SkeletonWrapper = styled.div`
  display: grid;

  @media (-ms-high-contrast: active), (-ms-high-contrast: none) {
    display: flex;
  }

  ${props =>
    props.whiteGoods &&
    css`
      margin: 15px 0;
    `}
`

export const HabitatLogo = styled(HabitatTextLogo)`
  margin-bottom: 5px;
`
